import { render, staticRenderFns } from "./WorkoutBookUserRow.vue?vue&type=template&id=6d6847a4"
import script from "./WorkoutBookUserRow.vue?vue&type=script&lang=js"
export * from "./WorkoutBookUserRow.vue?vue&type=script&lang=js"
import style0 from "./WorkoutBookUserRow.vue?vue&type=style&index=0&id=6d6847a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
